
/* ==========================================
   TIMI FRIENDLY ICON NAMES v1.1
   All five Zepto icon fields

   Changes customer-facing names only.

   Preserves:
   - Original Zepto icon IDs
   - Image URLs
   - Icon selection
   - Live preview
   - Pricing
   ========================================== */

(() => {
  'use strict';

  if (window.__timiFriendlyIconNamesV11) return;
  window.__timiFriendlyIconNamesV11 = true;

  const collections = [
    'CountryClubDogMom',
    'DolceVitaSummer',
    'EclecticRetro',
    'alt-girl-era-set',
    'cozy-sewing-set',
    'back-to-school',
    'fall-in-love-set',
    'coquette-summer',
    'western-rodeo',
    'preppy-summer',
    'casino-theme',
    'reading-theme',
    'sewing-theme',
    'pastel-theme',
    'sports-balls',
    'pink-summer',
    'y2k-theme',
    'y2k-edgy',
    '20-mini-icons',
    'mom-hobbies',
    'lucky-girl',
    'mini-lobster',
    'wedding',
    'witchy',
    'zodiac'
  ];

  const overrides = {
    '777': '777',

    'a-plus-back-to-school': 'A+',

    'abc-letters-back-to-school':
      'ABC Letters',

    'needle-thread-sewing-theme':
      'Needle + Thread',

    'yarn-ball-knitting-needles-mom-hobbies':
      'Yarn Ball + Knitting Needles',

    'eight-ball-casino-theme': '8 Ball',
    'eight-ball-lucky-girl': '8 Ball',
    'eight-ball-pink-summer': '8 Ball',
    'eight-ball-y2k-theme': '8 Ball',
    'eight-ball-sports-balls': '8 Ball',

    'triple-sevens-casino-theme': 'Triple 7s',
    'triple-sevens-lucky-girl': 'Triple 7s'
  };

  const FIELD_SELECTOR = [
    '.pplr-wrapper.pplr-icon-1',
    '.pplr-wrapper.pplr-icon-2',
    '.pplr-wrapper.pplr-icon-3',
    '.pplr-wrapper.pplr-icon-4',
    '.pplr-wrapper.pplr-icon-5'
  ].join(', ');

  const SWATCH_SELECTOR =
    '.pplr-swatch-element.pplrimage[data-val]';

  function friendlyName(id) {
    if (!id) return '';

    if (overrides[id]) {
      return overrides[id];
    }

    let name = id;

    const suffix = collections.find(collection =>
      id.toLowerCase().endsWith(
        '-' + collection.toLowerCase()
      )
    );

    if (suffix) {
      name = id.slice(
        0,
        -(suffix.length + 1)
      );
    }

    return name
      .replace(/[-_]+/g, ' ')
      .replace(/\b\w/g, letter =>
        letter.toUpperCase()
      )
      .replace(/\bY2k\b/gi, 'Y2K');
  }

  function setDisplayText(element, text) {
    if (
      element &&
      element.textContent !== text
    ) {
      element.textContent = text;
    }
  }

  function updateSwatchNames(field) {
    field.querySelectorAll(
      SWATCH_SELECTOR
    ).forEach(swatch => {
      const originalId =
        swatch.getAttribute('data-val');

      if (!originalId) return;

      const displayName =
        friendlyName(originalId);

      // Visible hover and dropdown labels.
      swatch.querySelectorAll(
        '.swtooltip > span, ' +
        '.img_dropdown .pplr-selecter-selected-label'
      ).forEach(label => {
        setDisplayText(
          label,
          displayName
        );
      });

      // Accessible name.
      if (
        swatch.getAttribute('aria-label') !==
        displayName
      ) {
        swatch.setAttribute(
          'aria-label',
          displayName
        );
      }

      // Native browser hover text.
      if (
        swatch.getAttribute('title') !==
        displayName
      ) {
        swatch.setAttribute(
          'title',
          displayName
        );
      }
    });
  }

  function updateSelectedIconName(field) {
    const label = field.querySelector(
      '.pplr_option_text_span.f_p_img'
    );

    if (!label) return;

    const selected = field.querySelector(
      '.pplr-swatch-element.pplrimage.selected[data-val]'
    );

    if (!selected) return;

    const originalId =
      selected.getAttribute('data-val');

    if (!originalId) return;

    setDisplayText(
      label,
      ' - ' + friendlyName(originalId)
    );
  }

  function updateAllIconNames() {
    document.querySelectorAll(
      FIELD_SELECTOR
    ).forEach(field => {
      updateSwatchNames(field);
      updateSelectedIconName(field);
    });
  }

  let scheduled = false;

  function scheduleUpdate() {
    if (scheduled) return;

    scheduled = true;

    requestAnimationFrame(() => {
      scheduled = false;
      updateAllIconNames();
    });
  }

  function start() {
    updateAllIconNames();

    const observer = new MutationObserver(
      records => {
        const relevant = records.some(record => {
          const target = record.target;

          if (
            target.nodeType === 1 &&
            target.matches?.(
              FIELD_SELECTOR
            )
          ) {
            return true;
          }

          if (
            target.nodeType === 1 &&
            target.closest?.(
              FIELD_SELECTOR
            )
          ) {
            return true;
          }

          if (record.type === 'childList') {
            return [
              ...record.addedNodes
            ].some(node =>
              node.nodeType === 1 &&
              (
                node.matches?.(
                  FIELD_SELECTOR
                ) ||
                node.querySelector?.(
                  FIELD_SELECTOR
                )
              )
            );
          }

          return false;
        });

        if (relevant) {
          scheduleUpdate();
        }
      }
    );

    observer.observe(document.body, {
      childList: true,
      subtree: true,
      characterData: true
    });

    window.addEventListener(
      'pageshow',
      updateAllIconNames
    );

    setTimeout(updateAllIconNames, 500);
    setTimeout(updateAllIconNames, 1500);

    console.log(
      'TIMI Friendly Icon Names v1.1 initialized'
    );
  }

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      start,
      { once: true }
    );
  } else {
    start();
  }
})();
